import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow",
  "use": "arrow-usage",
  "viewBox": "0 0 15 26",
  "content": "<symbol viewBox=\"0 0 15 26\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow\"><path d=\"M2 2L13 13L2 24\" stroke-width=\"2\" stroke-linecap=\"square\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol